import { marked } from 'marked';

export function markdownToHtml(text){
  return text ? marked(text, { breaks: true }) : '';
};
